import axios from 'axios';
import config from 'js/config';

// api endpoint prefixes
// Aurora: /api/
// Solaris: /public/
// Solaris: /private/

export const get = (url, args) => {
  return axios.get(`${config.build.apiPath}${url}`, { withCredentials: true, ...args });
};

export const post = (url, args) => {
  return axios.post(`${config.build.apiPath}${url}`, args, { withCredentials: true });
};

export const put = (url, args) => {
  return axios.put(`${config.build.apiPath}${url}`, args, { withCredentials: true });
};

export const del = (url) => {
  return axios.delete(`${config.build.apiPath}${url}`, { withCredentials: true });
};



// WEBPACK FOOTER //
// ./app/assets/api/api.js